<template>
  <el-dialog
    :title="dialogTitle"
    :visible="visible"
    width="720px"
    :close-on-click-modal="false"
    class="page-dialog center-dialog"
    @update:visible="val => $emit('update:visible', val)"
    @closed="handleClosed"
  >
    <div class="dialog-content">
      <el-form ref="formRef" :model="localFormData" :rules="formRules" label-position="top" size="small">
        <!-- 轮播标题 -->
        <el-form-item label="轮播标题" prop="title">
          <el-input v-model="localFormData.title" placeholder="请输入轮播标题" maxlength="100" show-word-limit></el-input>
        </el-form-item>

        <!-- 跳转类型 -->
        <el-form-item label="跳转类型" prop="jump_type">
          <el-radio-group v-model="localFormData.jump_type" @change="handleJumpTypeChange">
            <el-radio label="link">指定链接</el-radio>
            <el-radio label="act">平台活动</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 指定链接配置 -->
        <div v-if="localFormData.jump_type === 'link'">
          <!-- 链接类型 -->
          <el-form-item label="链接类型" prop="url_type">
            <el-select v-model="localFormData.url_type" placeholder="请选择链接类型" @change="handleLinkTypeChange">
              <el-option label="无链接" value="none"></el-option>
              <el-option label="站内链接" value="inner"></el-option>
              <el-option label="站外链接" value="outer"></el-option>
            </el-select>
          </el-form-item>

          <!-- 打开方式 -->
          <el-form-item v-if="localFormData.url_type === 'outer'" label="打开方式" prop="open_type">
            <el-select v-model="localFormData.open_type" placeholder="请选择打开方式">
              <el-option label="新页签" value="new_tab"></el-option>
              <el-option label="内嵌" value="embed"></el-option>
            </el-select>
          </el-form-item>

          <!-- 详情链接 -->
          <el-form-item v-if="localFormData.url_type === 'inner' || localFormData.url_type === 'outer'" label="详情链接" prop="jump_url">
            <el-input v-model="localFormData.jump_url" placeholder="请输入详情链接" maxlength="255" show-word-limit></el-input>
            <div v-if="localFormData.url_type === 'inner'" class="link-tip">站内链接以/开头</div>
            <div v-else-if="localFormData.url_type === 'outer'" class="link-tip">站外链接以http或https开头</div>
          </el-form-item>
        </div>

        <!-- 平台活动配置 -->
        <div v-else-if="localFormData.jump_type === 'act'">
          <el-form-item label="平台活动" prop="act_id">
            <div style="display: flex; gap: 10px; align-items: center">
              <!-- <el-input v-model="localFormData.act_name" placeholder="请选择平台活动" readonly style="width: 160px" /> -->
              <LanguageInputEcho :obj="localFormData.act_title || {}" size="mini" />
              <span style="color: #909399; font-size: 12px">(活动ID：{{ localFormData.act_id }})</span>
              <el-button size="small" type="primary" @click="activityDialogVisible = true">选择</el-button>
            </div>
          </el-form-item>
        </div>

        <!-- 排序 -->
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="localFormData.sort" :controls="false" :min="0" :step="1" style="width: 160px" placeholder="请输入排序序号"></el-input-number>
        </el-form-item>

        <!-- 展示时间 -->
        <el-form-item label="展示时间" prop="isPermanent">
          <el-radio-group v-model="localFormData.isPermanent" @change="handleShowTimeChange">
            <el-radio :label="true">永久有效</el-radio>
            <el-radio :label="false">指定时间</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 指定时间配置 -->
        <div v-if="!localFormData.isPermanent" class="time-range">
          <el-row :gutter="20" style="margin-bottom: 0">
            <el-col :span="12">
              <el-form-item label="开始时间" prop="start_at">
                <el-date-picker
                  v-model="localFormData.start_at"
                  type="datetime"
                  placeholder="请选择开始时间"
                  style="width: 100%"
                  :picker-options="startPickerOptions"
                  @change="handleTimeChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间" prop="end_at">
                <el-date-picker
                  v-model="localFormData.end_at"
                  type="datetime"
                  placeholder="请选择结束时间"
                  style="width: 100%"
                  :picker-options="endPickerOptions"
                  @change="handleTimeChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 轮播图片 -->
        <el-form-item label="轮播广告图片(1张)" prop="image_url">
          <SingleImageUpload v-model="localFormData.image_url" tip="支持jpg、jpeg、png格式" size="100" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="loading || dialogLoading" @click="handleConfirm">确定</el-button>
    </div>

    <ActivitySelectDialog :visible.sync="activityDialogVisible" @select="handleActivitySelect" />
  </el-dialog>
</template>

<script>
// import adApi from '@/mock/ad.js' // 注释掉mock API
import { createBanner, updateBanner } from '@/api/operation/carouselAd.js'
import SingleImageUpload from '@/components/Upload/SingleImageUpload.vue'
import ActivitySelectDialog from '@/pages/admin/operation/ad/components/ActivitySelectDialog.vue'
import LanguageInputEcho from '@/components/LanguageInputEcho/index.vue'

export default {
  name: 'ManageCarouselAdDialog',
  components: { SingleImageUpload, ActivitySelectDialog, LanguageInputEcho },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dialogTitle: {
      type: String,
      default: '新增轮播图广告',
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
    dialogLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 表单数据 - 直接使用API模型字段名
      localFormData: {
        id: '',
        title: '',
        jump_type: 'link',
        url_type: 'none',
        open_type: 'new_tab',
        jump_url: '',
        act_id: '',
        act_name: '',
        act_title: {},
        sort: 0,
        isPermanent: true,
        start_at: '',
        end_at: '',
        image_url: '',
        status: 'enabled',
      },
      // 加载状态
      loading: false,
      activityDialogVisible: false,
    }
  },
  computed: {
    // 动态表单验证规则
    formRules() {
      return {
        title: [{ required: true, message: '请输入轮播标题', trigger: 'blur' }],
        jump_type: [{ required: true, message: '请选择跳转类型', trigger: 'change' }],
        url_type: [{ required: this.localFormData.jump_type === 'link', message: '请选择链接类型', trigger: 'change' }],
        open_type: [
          {
            required: this.localFormData.jump_type === 'link' && this.localFormData.url_type !== 'none',
            message: '请选择打开方式',
            trigger: 'change',
          },
        ],
        jump_url: [
          {
            required: this.localFormData.jump_type === 'link' && this.localFormData.url_type !== 'none',
            message: '请输入详情链接',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (this.localFormData.jump_type === 'link' && this.localFormData.url_type === 'inner') {
                if (!value.startsWith('/')) {
                  callback(new Error('站内链接必须以/开头'))
                } else {
                  callback()
                }
              } else if (this.localFormData.jump_type === 'link' && this.localFormData.url_type === 'outer') {
                if (!value.startsWith('http://') && !value.startsWith('https://')) {
                  callback(new Error('站外链接必须以http://或https://开头'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        act_id: [
          {
            required: this.localFormData.jump_type === 'act',
            message: '请选择平台活动',
            trigger: 'change',
          },
        ],
        sort: [{ required: true, message: '请输入排序序号', trigger: 'blur' }],
        start_at: [
          {
            required: !this.localFormData.isPermanent,
            message: '请选择开始时间',
            trigger: 'change',
          },
        ],
        end_at: [
          {
            required: !this.localFormData.isPermanent,
            message: '请选择结束时间',
            trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              if (this.localFormData.isPermanent) {
                callback()
                return
              }
              const start = this.localFormData.start_at
              const end = this.localFormData.end_at
              if (!start || !end) {
                callback()
                return
              }
              if (start >= end) {
                callback(new Error('结束时间必须大于开始时间'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        image_url: [{ required: true, message: '请上传轮播图片', trigger: 'change' }],
      }
    },
    startPickerOptions() {
      return {
        disabledDate: time => {
          if (this.localFormData.isPermanent) return false
          const end = this.localFormData.end_at
          if (!end) return false
          const endTs = end instanceof Date ? end.getTime() : end
          return time.getTime() >= endTs
        },
      }
    },
    endPickerOptions() {
      return {
        disabledDate: time => {
          if (this.localFormData.isPermanent) return false
          const start = this.localFormData.start_at
          if (!start) return false
          const startTs = start instanceof Date ? start.getTime() : start
          return time.getTime() <= startTs
        },
      }
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initForm()
      }
    },
  },
  methods: {
    // 初始化表单数据
    initForm() {
      // 重置表单数据 - 使用API模型字段名
      const defaultFormData = {
        id: '',
        title: '',
        jump_type: 'link',
        url_type: 'none',
        open_type: 'new_tab',
        jump_url: '',
        act_id: '',
        act_name: '',
        act_title: {},
        sort: 1,
        isPermanent: true,
        start_at: '',
        end_at: '',
        image_url: '',
        status: 'enabled',
      }

      // 合并默认数据和传入的表单数据
      this.localFormData = Object.assign({}, defaultFormData, this.$props.formData)

      // 计算是否为永久有效
      this.localFormData.isPermanent = !this.localFormData.end_at || this.localFormData.end_at === -1
    },

    // 跳转类型变化
    handleJumpTypeChange() {
      if (this.localFormData.jump_type === 'link') {
        this.localFormData.url_type = 'none'
        this.localFormData.open_type = 'new_tab'
        this.localFormData.jump_url = ''
        this.localFormData.act_id = ''
        this.localFormData.act_name = ''
      } else {
        this.localFormData.url_type = ''
        this.localFormData.open_type = ''
        this.localFormData.jump_url = ''
        this.localFormData.act_id = ''
        this.localFormData.act_name = ''
      }
    },

    // 链接类型变化
    handleLinkTypeChange() {
      if (this.localFormData.url_type === 'none') {
        this.localFormData.open_type = ''
        this.localFormData.jump_url = ''
      } else {
        this.localFormData.open_type = this.localFormData.open_type || 'new_tab'
      }
    },

    handleActivitySelect(row) {
      const actId = row && row.act_id != null ? row.act_id : ''
      const title = row && row.title != null ? row.title : ''
      this.localFormData.act_name = title
      this.localFormData.act_title = title
      this.localFormData.act_id = actId
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.validateField('act_id')
      })
    },

    // 展示时间变化
    handleShowTimeChange() {
      if (this.localFormData.isPermanent) {
        this.localFormData.start_at = Math.floor(new Date().getTime())
        this.localFormData.end_at = -1
      } else {
        this.localFormData.start_at = ''
        this.localFormData.end_at = ''
      }
    },

    // 时间选择器变化 - 将Date对象转换为时间戳
    handleTimeChange() {
      if (!this.localFormData.isPermanent) {
        if (this.localFormData.start_at instanceof Date) {
          this.localFormData.start_at = Math.floor(this.localFormData.start_at.getTime())
        }
        if (this.localFormData.end_at instanceof Date) {
          this.localFormData.end_at = Math.floor(this.localFormData.end_at.getTime())
        }
      }
    },

    // 表单验证
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.formRef.validate(valid => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('表单验证失败'))
          }
        })
      })
    },

    // 转换表单数据为API格式 - 由于localFormData已使用API字段名，只需处理时间和必要字段
    transformFormData() {
      // 构建API请求数据
      const apiData = {
        ...this.localFormData,
      }

      // 处理时间范围
      if (this.localFormData.isPermanent) {
        apiData.start_at = new Date().getTime()
        apiData.end_at = -1 // 永久有效
      }

      // 移除不需要的字段
      delete apiData.isPermanent

      return apiData
    },

    // 确认
    async handleConfirm() {
      try {
        await this.validateForm()
        this.loading = true

        // 转换表单数据为API格式
        const apiData = this.transformFormData()

        let response
        if (this.localFormData.id) {
          // 编辑
          response = await updateBanner(apiData)
        } else {
          // 新增
          response = await createBanner(apiData)
        }
        if (response.code === 0) {
          this.$message.success('操作成功')
          this.$emit('success')
          this.handleCancel()
        } else {
          // this.$message.error('操作失败：' + (response.msg || '未知错误'))
          console.error('操作失败：' + (response.msg || '未知错误'))
        }
      } catch (error) {
        // if (error.message !== '表单验证失败') {
        //   this.$message.error('操作失败：' + error.message)
        // }
        console.error('操作失败：' + error.message)
      } finally {
        this.loading = false
      }
    },

    // 取消
    handleCancel() {
      this.$emit('update:visible', false)
    },

    // 弹窗关闭回调
    handleClosed() {
      // 重置表单
      this.$refs.formRef?.resetFields()
      this.initForm()
    },
  },
}
</script>

<style scoped>
.dialog-content {
  padding: 0 0 20px 0;
}

.link-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}

.time-range {
  margin-top: 10px;
}
</style>
